export default __webpack_public_path__ + "static/media/zawodniczka3.22f3fd5c.png";